<script>
import { mapGetters } from "vuex";

/**
 * @component App
 * @description Root component. Hidrata el contexto de la org del user al
 *              montar (branding + flags via /organization/me) y aplica
 *              CSS custom properties al :root para que sub-componentes
 *              (sidebar, headers, botones) puedan referenciar los colores
 *              de la org en lugar de los hardcoded del tenant.
 *
 *              Fallback: si la org NO tiene branding o si /organization/me
 *              falla, no se setean CSS vars y los componentes caen al
 *              branding del tenant (build-time env vars o defaults SCSS).
 */
export default {
  name: "App",

  computed: {
    ...mapGetters(["orgBranding"]),
  },

  created() {
    // UC-REG-067 + UC-REG-068. Hidratar contexto de la org si hay un token
    // activo (user logueado). En portal público / login no hay token y
    // saltamos. La action es fail-silent — no rompe nada si el endpoint
    // /organization/me no responde.
    if (this.$store.state.token) {
      this.$store.dispatch("loadOrganizationContext");
    }
  },

  watch: {
    /**
     * @description Aplica los colores de branding de la org como CSS custom
     *              properties globales. Componentes pueden usar:
     *                color: var(--org-color-primary, #002d5e);
     *                background: var(--org-color-accent, #0a3d7a);
     *              y si la org no tiene branding, cae al fallback hardcoded.
     */
    orgBranding: {
      immediate: true,
      handler(branding) {
        if (typeof document === "undefined") return;
        const root = document.documentElement;
        if (branding && branding.colorPrimary) {
          root.style.setProperty("--org-color-primary", branding.colorPrimary);
        } else {
          root.style.removeProperty("--org-color-primary");
        }
        if (branding && branding.colorAccent) {
          root.style.setProperty("--org-color-accent", branding.colorAccent);
        } else {
          root.style.removeProperty("--org-color-accent");
        }
        if (branding && branding.fontFamily) {
          root.style.setProperty("--org-font-family", branding.fontFamily);
        } else {
          root.style.removeProperty("--org-font-family");
        }
      },
    },
  },
};
</script>

<template lang="pug">
  #app.theme
    router-view
</template>
